import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "./../../../environments/environment";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-genere-list",
  templateUrl: "./genere-list.component.html",
  styleUrls: ["./genere-list.component.css"],
})
export class GenereListComponent implements OnInit {
  constructor(
    private pagesService: BaseService,
    private route: ActivatedRoute
  ) {}
  contentData = [];
  apiParam = { slug: "", limit: 20, offset: 0, subslug: "" };
  shimarStatus = true;
  appConstant: any;
  loadMore: boolean;
  genereData: any = {};
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.appConstant = environment;
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
        this.apiParam.subslug = params["subslug"];
      }
      this.getData();
    });
  }

  getData() {
    this.pagesService
      .getDataBySubGenere(this.apiParam)
      .subscribe((data: any) => {
        this.genereData = data.results;
        this.contentData = this.contentData.concat(data.results.content);
        this.shimarStatus = false;
        this.loadMore = false;
      });
  }

  onScroll() {
    this.loadMore = true;
    const offset = this.apiParam.limit + this.apiParam.offset;
    if (this.genereData.content_count > offset) {
      if (this.contentData.length > 0) {
        this.apiParam.offset += offset;
        this.getData();
      }
    } else {
      this.loadMore = false;
    }
  }
}
